'use strict';

// Keep this in sync with AccountExternalService.class.php

module.exports = {
    'BOXNET': 'B',
    'DROPBOX': 'D',
    'GOOGLE_DRIVE': 'G',
    'GOOGLE_APPS': 'A',
    'GOOGLE_DOCS': 'F',
    'EVERNOTE': 'E',
    'MS_SP': 'S',
    'MS_OFFICE': 'O',
    'MS_OUTLOOK': 'L',
    'SKYDRIVE': 'K', // OneDrive
    'QQ_CATALYST': 'Q',
    'HUBSPOT': 'H',
    'SLACK': 'C',
    'EVENTBRITE': 'V',
    'SALESFORCE': 'M',
    'ORACLECLOUD': 'R',
    'ALL': 'ALL' // used when calling syncFileWrapper.php worker
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/common/constants/ExternalServiceTypes.js
 ** module id = 723
 ** module chunks = 0
 **/